import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "@/api/base";
import { DocumentChronology } from "@/types/chronology";
import { FILES_TAG, filesApi } from "@/api/files";

const TAG = "document-chronology";
const TAG_NARRATIVE = "document-chronology-narrative";

export const chronologyApi = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: "/pf-document/" }),
  reducerPath: "chronologyApi",
  tagTypes: [TAG, TAG_NARRATIVE],
  endpoints: builder => ({
    getNarrativeChronology: builder.query<string, string>({
      providesTags: [TAG_NARRATIVE],
      query: fse_id => ({
        url: "chronologies/narrative",
        method: "POST",
        data: {
          fse_id,
        },
      }),
    }),
    createChronologies: builder.mutation<{ tx_id: string }, string>({
      invalidatesTags: [TAG],
      query: fse_id => ({
        url: `chronologies/chronologize`,
        method: "POST",
        data: {
          fse_id,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(filesApi.util.invalidateTags([FILES_TAG]));
      },
    }),
    deleteChronoRecord: builder.mutation<void, string>({
      invalidatesTags: [TAG, TAG_NARRATIVE],
      query: id => ({
        url: `chronologies/chronorecord/${id}`,
        method: "DELETE",
      }),
    }),
    updateChronoRecord: builder.mutation<
      void,
      {
        data: {
          transaction_fse_id: string;
          fse_id: string;
          tx_id: string;
          day?: number | null;
          month?: number;
          year?: number;
          quote?: string;
        };
        id?: string;
      }
    >({
      invalidatesTags: [TAG, TAG_NARRATIVE],
      query: ({ id, data }) => ({
        url: id ? `chronologies/chronorecord/${id}` : "chronologies/chronorecord",
        method: id ? "PATCH" : "POST",
        data: {
          ...data,

          end_day: -1,
          end_month: -1,
          end_year: -1,
          date_action: "",
          quote: "",
        },
      }),
    }),
    getDocumentChronology: builder.query<DocumentChronology, string>({
      providesTags: [TAG],
      query: fseId => ({
        url: `chronologies/fse-chronology/${fseId}`,
      }),
    }),
  }),
});

export const {
  useGetDocumentChronologyQuery,
  useGetNarrativeChronologyQuery,
  useCreateChronologiesMutation,
  useUpdateChronoRecordMutation,
  useDeleteChronoRecordMutation,
} = chronologyApi;
